// extracted by mini-css-extract-plugin
export default {"link":"style_link__SYeP2","active":"style_active__WbZSF","line":"style_line__CUJ0N","title":"style_title__mXHls","desc":"style_desc__jqzG-"};